// extracted by mini-css-extract-plugin
module.exports = {"label":"_1fb00b78","hide":"_a3b05f1e"};